import { images } from '.'; 

const portfolio = [ 
    {
        id: 1,
        image: images.portfolio1,
        title: 'SUV Sales',
        details: {
            date: 'January 15, 2024',
            audience: 'Auto Enthusiasts & Dealerships',
            category: 'Vehicle Sales',
            duration: '6 weeks',
            location: 'Los Angeles, USA',
            revenue: '$45,000',
            organizer: 'Elite Auto Group',
        },
        paragraphs: [
            'A premium SUV sales project focused on delivering high-performance, luxury, and off-road capability to customers. Our dealership provided a curated selection of top-tier SUVs, ensuring buyers received the perfect blend of power, comfort, and innovation.',
            'This project highlighted exclusive deals on high-end models, comprehensive financing options, and exceptional after-sales services, making it the go-to destination for SUV enthusiasts seeking reliability and value.'
        ],
        gallery: [   
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6,
        ],
        challenges: {
            intro: 'Selling high-end SUVs comes with challenges such as market competition, financing options, and ensuring customers receive value for their investment.',
            points: [
                'High market competition',
                'Customer financing concerns',
                'Balancing luxury and affordability',
                'Limited inventory availability',
                'Demand for eco-friendly models'
            ],
        },
        solutions: {
            intro: 'Our approach combined premium vehicle selection with customer-centric services and flexible financing plans to create a seamless purchasing experience.',
            points: [
                'Exclusive SUV model showcase',
                'Custom financing solutions',
                'Personalized test drive experiences',
                'Extended warranty packages',
                'Hybrid and electric SUV options'
            ],
        },
        results: {
            intro: 'The SUV sales project successfully boosted dealership revenue while enhancing customer satisfaction and brand reputation in the competitive automotive industry.',
            points: [
                'Increased SUV sales volume',
                'Higher customer satisfaction rates',
                'Expanded dealership inventory',
                'Improved financing approval rates',
                'Strengthened brand loyalty'
            ],
        },
    },
    {
        id: 2,
        image: images.portfolio2,
        title: 'Luxury Rentals',
        details: {
            date: 'March 10, 2024',
            audience: 'Luxury Travelers & Business Executives',
            category: 'Car Rentals',
            duration: 'Ongoing',
            location: 'Miami, USA',
            cost: 'Starting from $299/day',
            organizer: 'Prestige Auto Rentals',
        },
        paragraphs: [
            'A high-end car rental service offering luxury and exotic vehicles for business professionals, travelers, and special events. Our fleet features top-tier brands like Rolls-Royce, Bentley, Lamborghini, and Mercedes-Benz.',
            'This project emphasized convenience, premium customer service, and flexible rental plans, ensuring an unforgettable driving experience for clients who demand the best in style and performance.'
        ],
        gallery: [   
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6,
        ],
        challenges: {
            intro: 'Luxury car rentals face challenges such as maintaining an exclusive fleet, ensuring top-tier customer satisfaction, and managing high-value assets effectively.',
            points: [
                'High maintenance and operational costs',
                'Demand for flexible rental options',
                'Ensuring vehicle availability during peak seasons',
                'Meeting high customer service expectations',
                'Managing insurance and security concerns'
            ],
        },
        solutions: {
            intro: 'Our approach focused on offering premium customer service, personalized rental experiences, and seamless booking solutions.',
            points: [
                'Exclusive fleet of luxury and exotic cars',
                '24/7 concierge and roadside assistance',
                'Flexible short-term and long-term rental plans',
                'VIP pickup and drop-off services',
                'Comprehensive insurance coverage for peace of mind'
            ],
        },
        results: {
            intro: 'The luxury car rental service has successfully positioned itself as a leading provider of high-end vehicles, attracting elite clientele and increasing brand prestige.',
            points: [
                'Expanded luxury fleet with top-tier brands',
                'Higher customer retention and satisfaction rates',
                'Increased rental bookings and revenue growth',
                'Enhanced brand image in the luxury market',
                'Streamlined booking and reservation process'
            ],
        },
    },
    {
        id: 3,
        image: images.portfolio3,
        title: 'Electric Cars',
        details: {
            date: 'April 15, 2024',
            audience: 'Eco-conscious Drivers & Tech Enthusiasts',
            category: 'Vehicle Sales',
            duration: 'Ongoing',
            location: 'Los Angeles, USA',
            cost: 'Starting from $35,000',
            organizer: 'Green Drive Auto Dealership',
        },
        paragraphs: [
            'A cutting-edge vehicle sales initiative focused on the future of mobility—electric cars. We offer a diverse range of EVs, including Tesla, Rivian, Lucid, and other top brands, providing sustainable transportation solutions.',
            'This project emphasizes innovation, environmental responsibility, and energy efficiency, helping customers transition from gasoline-powered vehicles to eco-friendly electric alternatives with ease.'
        ],
        gallery: [   
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6,
        ],
        challenges: {
            intro: 'The transition to electric vehicles comes with key challenges, including customer education, charging infrastructure, and upfront costs.',
            points: [
                'Limited public charging stations in some areas',
                'Higher initial purchase cost compared to gasoline vehicles',
                'Educating buyers on battery life and maintenance',
                'Concerns about driving range and charging time',
                'Availability of government incentives and rebates'
            ],
        },
        solutions: {
            intro: 'Our dealership provides comprehensive solutions to make EV ownership more accessible and rewarding.',
            points: [
                'Partnerships with charging station providers',
                'Financing options and government rebate assistance',
                'Expert consultations on EV technology and benefits',
                'Test drive programs to experience electric driving',
                'Extended battery warranties and service packages'
            ],
        },
        results: {
            intro: 'The electric car sales program has successfully driven higher EV adoption rates and positioned our dealership as a leader in sustainable mobility.',
            points: [
                'Increased electric vehicle sales by 40%',
                'Enhanced customer awareness of EV benefits',
                'Expanded inventory with the latest electric models',
                'Established trust as an eco-friendly dealership',
                'Contributed to a greener, emission-free future'
            ],
        },
    },
    {
        id: 4,
        image: images.portfolio4,
        title: 'Engine Repair',
        details: {
            date: 'May 10, 2024',
            audience: 'Car Owners & Fleet Managers',
            category: 'Car Servicing',
            duration: '1-3 Days (Depending on Repair Type)',
            location: 'New York, USA',
            cost: 'Starting from $500',
            organizer: 'Precision Auto Repair Center',
        },
        paragraphs: [
            'Our expert engine repair service is dedicated to diagnosing and resolving all engine-related issues to restore peak performance. From minor fixes to complete overhauls, we ensure your vehicle runs smoothly and efficiently.',
            'We specialize in repairing and replacing engine components, optimizing fuel efficiency, and preventing long-term damage. Whether it’s unusual noises, overheating, or reduced power, our certified technicians provide reliable solutions.'
        ],
        gallery: [   
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6,
        ],
        challenges: {
            intro: 'Engine problems can arise from various factors, leading to costly breakdowns if not addressed promptly.',
            points: [
                'Overheating due to coolant leaks or radiator issues',
                'Unusual engine noises indicating wear or misalignment',
                'Loss of power or poor fuel efficiency',
                'Check engine light warnings requiring diagnostics',
                'Excessive smoke or oil leaks from the engine'
            ],
        },
        solutions: {
            intro: 'Our certified mechanics use advanced tools and genuine parts to ensure lasting engine performance.',
            points: [
                'Comprehensive engine diagnostics and troubleshooting',
                'Cylinder head, gasket, and piston repairs',
                'Oil leak detection and gasket replacement',
                'Cooling system and radiator maintenance',
                'Engine tuning for maximum efficiency'
            ],
        },
        results: {
            intro: 'Our engine repair services have helped countless customers enhance vehicle reliability and longevity.',
            points: [
                'Restored engine power and fuel efficiency',
                'Extended engine lifespan with proper maintenance',
                'Reduced unexpected breakdown risks',
                'Improved vehicle emissions and environmental compliance',
                'Customer satisfaction with reliable repair services'
            ],
        },
    },
    {
        id: 5,
        image: images.portfolio5,
        title: 'Family Rentals',
        details: {
            date: 'June 15, 2024',
            audience: 'Families & Travel Groups',
            category: 'Car Rentals',
            duration: 'Flexible Rental Periods (Daily, Weekly, Monthly)',
            location: 'Los Angeles, USA',
            cost: 'Starting from $70/day',
            organizer: 'Comfort Drive Car Rentals',
        },
        paragraphs: [
            'Our Family Rentals service offers spacious and comfortable vehicles designed to make family trips enjoyable and stress-free. Whether planning a road trip, vacation, or weekend getaway, we provide the perfect rental car for your needs.',
            'We offer a wide selection of minivans, SUVs, and family sedans equipped with modern safety features, entertainment systems, and ample storage space. Our rental process is quick, easy, and designed for your convenience.'
        ],
        gallery: [   
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6,
        ],
        challenges: {
            intro: 'Finding the perfect family rental can be challenging, especially when considering safety, comfort, and affordability.',
            points: [
                'Limited legroom and cargo space in standard rentals',
                'Lack of child-friendly features and safety options',
                'High fuel consumption in larger vehicles',
                'Complicated rental terms and hidden fees',
                'Availability issues during peak seasons'
            ],
        },
        solutions: {
            intro: 'Our Family Rentals service ensures a seamless and comfortable experience with well-maintained vehicles and family-friendly features.',
            points: [
                'Spacious SUVs and minivans for ultimate comfort',
                'Child safety seats and booster options available',
                'Fuel-efficient models for cost-effective trips',
                'Easy booking process with flexible rental terms',
                '24/7 roadside assistance for peace of mind'
            ],
        },
        results: {
            intro: 'Our customers enjoy hassle-free family trips with safe, reliable, and budget-friendly rental options.',
            points: [
                'Increased comfort with spacious and well-equipped vehicles',
                'Safe travel with advanced security features',
                'Affordable pricing with transparent rental terms',
                'Smooth booking experience and excellent customer support',
                'Memorable family road trips without transportation worries'
            ],
        },
    },
    {
        id: 6,
        image: images.portfolio6,
        title: 'Oil Change',
        details: {
            date: 'July 10, 2024',
            audience: 'Car Owners & Fleet Operators',
            category: 'Car Servicing',
            duration: '30-45 Minutes',
            location: 'Houston, USA',
            cost: 'Starting from $39.99',
            organizer: 'Precision Auto Care',
        },
        paragraphs: [
            'Regular oil changes are essential for maintaining engine health and prolonging the lifespan of your vehicle. Our professional oil change service ensures your engine stays lubricated, runs efficiently, and avoids unnecessary wear and tear.',
            'We offer high-quality synthetic, semi-synthetic, and conventional oil options tailored to your vehicle’s specific needs. Our technicians also perform a complimentary multi-point inspection to ensure optimal vehicle performance.'
        ],
        gallery: [   
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6,
        ],
        challenges: {
            intro: 'Neglecting regular oil changes can lead to serious engine damage, costly repairs, and reduced vehicle efficiency.',
            points: [
                'Increased engine wear and tear',
                'Decreased fuel efficiency',
                'Overheating due to poor lubrication',
                'Buildup of harmful engine sludge',
                'Reduced overall engine lifespan'
            ],
        },
        solutions: {
            intro: 'Our expert oil change service helps maintain your engine’s performance and prevent costly repairs.',
            points: [
                'High-quality oil options tailored to your car’s needs',
                'Quick and efficient service with minimal wait time',
                'Complimentary multi-point vehicle inspection',
                'Eco-friendly disposal of used oil',
                'Extended engine life with routine maintenance'
            ],
        },
        results: {
            intro: 'Our customers experience improved engine performance, increased fuel efficiency, and long-term savings on maintenance.',
            points: [
                'Smoother and quieter engine operation',
                'Enhanced fuel efficiency with clean engine oil',
                'Reduced risk of engine breakdowns',
                'Longer lifespan for critical engine components',
                'Confidence in a well-maintained vehicle'
            ],
        },
    },
];

export default portfolio;

